// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Adicionar portfólio',
    copy_custom_fields_label: 'Copiar campos personalizados do portfólio pai',
    delete_portfolio_title: 'Excluir portfólio \"{0}\"?',
    DeletionIsUsedDisabled: 'Não é possível excluir o status, pois há um portfólio com este status.',
    Editor: 'Editor de portfólio',
    Manager: 'Gerente de portfólio',
    members: '1#{0} membro de portfólio#{0} membros de portfólio',
    new_portfolio: 'Novo portfólio',
    NewStatusTitle: 'Adicionar status',
    ParentPortfolio: 'Portfólio pai',
    permissions_title: 'Esta função tem as seguintes permissões em relação ao portfólio e projetos nele',
    Portfolios: 'Portfólios',
    role_for_this_portfolio: 'Função para este portfólio:',
    Statuses: 'Status',
    Teamer: 'Participante de portfólio',
    Viewer: 'Visualizador de portfólio',
};
